import { getOptinsByTenantAndCountry } from "../service/OptinService"
import { useQuery } from "react-query"

export default function useGetOptinsByTenantAndCountry(tunnelData, enabled, stepName) {
  const { data: optins, isLoading: isLoadingOptins } = useQuery({
    queryKey: ["get-optins", tunnelData?.tenant, stepName],
    queryFn: () => getOptinsByTenantAndCountry(tunnelData),
    enabled: enabled,
    refetchOnWindowFocus: false
  })

  return { optins, isLoadingOptins }
}
